import { useEffect, useRef, useState } from 'react';

const ImageCard = ({ src, title, description, onClick, className = "" }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isInView, setIsInView] = useState(false);
    const [hasError, setHasError] = useState(false);
    const imgRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const handleImageLoad = () => {
        setIsLoaded(true);
    };

    const handleImageError = () => {
        setHasError(true);
        setIsLoaded(true);
    };

    return (
        <div 
            ref={imgRef}
            className={`bg-primary border border-orange-300 shadow rounded overflow-hidden transition-all duration-300 hover:shadow-xl flex flex-col ${className}`}
            onClick={onClick}
            data-testid="image-card-container"
        >
            <div className="relative w-full bg-gray-200 flex-shrink-0">
                {/* Skeleton placeholder */}
                {!isLoaded && (
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse">
                        <div className="flex items-center justify-center h-full min-h-[200px]">
                            <div className="w-12 h-12 border-4 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    </div>
                )}
                
                {/* Actual image */}
                {isInView && (
                    <>
                        {hasError ? (
                            <div className="flex items-center justify-center h-64 bg-gray-100 text-gray-500">
                                <div className="text-center">
                                    <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                                    </svg>
                                    <p className="text-sm">Image not available</p>
                                </div>
                            </div>
                        ) : (
                            <img 
                                src={src} 
                                alt={title} 
                                className={`w-full h-auto object-contain transition-opacity duration-300 ${
                                    isLoaded ? 'opacity-100' : 'opacity-0'
                                }`}
                                onLoad={handleImageLoad}
                                onError={handleImageError}
                                loading="lazy"
                                style={{
                                    minHeight: '200px',
                                    maxHeight: '500px'
                                }}
                            />
                        )}
                    </>
                )}
            </div>
            
           
        </div>
    );
};

export default ImageCard;
